import service from '@/services/contabilidad/account'

const getDefaultState = () => ({
  list: []
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState())
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
  },

  readByEmisor: async ({ state, dispatch, rootGetters, commit }, { restart = false }) => {
    if (restart) await dispatch('resetList')

    if (state.list.length) {
      return
    }

    return service.readByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      if (!response) return

      state.list = response?.exchanges

      const usd = state.list.find(e => e._id === '5efcc43a1feb334e4d493405') // "5efcc43a1feb334e4d493405" = USD

      if (usd && !usd.auto) {
        commit('facturacion/facturaStore/SET_TIPO_CAMBIO', { venta: usd.rate }, { root: true })
        commit('inventario/facturaCompraStore/SET_TIPO_CAMBIO', { venta: usd.rate }, { root: true })
      }
    })
  }
}

export const getters = {}
